// extracted by mini-css-extract-plugin
export default {"nhima-header":"NhimaReport_nhima-header__T3xHA","divider":"NhimaReport_divider__VTHlU"};